import React from "react";
import styles from "./Branding3D.module.css";
import { Link } from "react-router-dom";
import DesignShowcase from "../../components/designShowcase/DesignShowcase";
import LineAnimation from "../../components/lineAnimations/LineAnimation";
import LineAnimationTwo from "../../components/lineAnimationsTwo/LineAnimationTwo";
import FAQ from "../../components/faq/Faq";

const Branding3D = () => {
  return (
    <>
      <div className={styles.pageBck}>
        <LineAnimation />
        <LineAnimationTwo />
        <div className={styles.pageBanner}>
          <h1>Brendimi 3D</h1>
          <span>3D BRANDING</span>
          <p>
            Shndërro hapësirën tënde me magjinë e projeksioneve 3D! 
            Transformo hapësirën tuaj me projektime kreative dhe mapping i dritës që krijon efekte vizuale të mrekullueshme.
          </p>
          <div className={styles.pageButtons}>
            <Link to="/contact">Na kontaktoni</Link>
          </div>
        </div>
      </div>

      <DesignShowcase
        reverse="reverse"
        image="/assets/images/inside.webp"
        title="Transformo hapësirën tënde me 3D që bie në sy!"
        text="Shndërro hapësirën tënde me magjinë e projeksioneve 3D!"
        keyOne="Projektime Kreative – Dizenjoni hapësira unike me projekte 3D që tërheqin vëmendjen."
        keyTwo="Mapping i Dritës – Krijoni efekte vizuale të mrekullueshme me teknologji 3D."
        keyThree="Kualitet që tërheq vëmendjen, dizajne që bëjnë përshtypje!"
      />

      <div className={styles.callUs}>
        <div className="subContainer">
          <h2>Gati për të nisur projektin tuaj?</h2>
          <Link to="/contact">Dërgo email</Link>
        </div>
      </div>

      <FAQ />
    </>
  );
};

export default Branding3D;

